(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[79067],{

/***/ 325523:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phongvu/desktop/buildpc",
      function () {
        return __webpack_require__(210627);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 210627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ desktop_buildpc; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ./components/HeadSection.tsx
var HeadSection = __webpack_require__(665207);
// EXTERNAL MODULE: ./containers/BuildPc/index.tsx + 7 modules
var BuildPc = __webpack_require__(316555);
// EXTERNAL MODULE: ./contexts/BuildPCContextV2.tsx
var BuildPCContextV2 = __webpack_require__(39486);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(982226);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/Breadcrumbs/Breadcrumbs.es.js
var Breadcrumbs_es = __webpack_require__(955006);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ./components/Loading.tsx
var Loading = __webpack_require__(235904);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/PrintBuildPc/PrintBuildPc.es.js
var PrintBuildPc_es = __webpack_require__(327601);
;// CONCATENATED MODULE: ./modules/buildpc/desktop/BuildPC.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  @media print {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











const PbBuildPC = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(93712), __webpack_require__.e(1393), __webpack_require__.e(96464), __webpack_require__.e(25700), __webpack_require__.e(75803), __webpack_require__.e(33249), __webpack_require__.e(12512), __webpack_require__.e(4857), __webpack_require__.e(50424), __webpack_require__.e(46921), __webpack_require__.e(88568), __webpack_require__.e(12583), __webpack_require__.e(59063), __webpack_require__.e(97736), __webpack_require__.e(70818), __webpack_require__.e(72992), __webpack_require__.e(71991), __webpack_require__.e(81826), __webpack_require__.e(97115), __webpack_require__.e(60342), __webpack_require__.e(48019), __webpack_require__.e(81430), __webpack_require__.e(27953), __webpack_require__.e(19303), __webpack_require__.e(20493), __webpack_require__.e(76414), __webpack_require__.e(92952), __webpack_require__.e(146), __webpack_require__.e(75566), __webpack_require__.e(80300), __webpack_require__.e(98459), __webpack_require__.e(68310), __webpack_require__.e(45590), __webpack_require__.e(49354), __webpack_require__.e(87280)]).then(__webpack_require__.bind(__webpack_require__, 170919)).then((mod)=>mod.PbPage), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(170919)
            ]
    }
});
const BuildPC = (param)=>{
    let { pbContent , pbMetaData , pbSSRData ,  } = param;
    var ref;
    const { epicOmni1524  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { loading , estimatedAmount , mappedPrintBuildPCData  } = (0,BuildPCContextV2/* useBuildPCV2 */.s)();
    const breadCrumbs = [
        {
            link: "/",
            name: (0,i18n.t)("Trang chủ")
        },
        {
            disabled: true,
            link: "#",
            name: "Build PC"
        }, 
    ];
    return epicOmni1524 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {
                isLoading: loading || false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadSection/* HeadSection */.I, _objectSpread({}, pbMetaData ? {
                            title: pbMetaData.metaTitle,
                            description: pbMetaData.metaDescription,
                            keywords: (ref = pbMetaData.metaKeywords) === null || ref === void 0 ? void 0 : ref.toString()
                        } : {})),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_es/* Container */.W, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_es/* Breadcrumbs */.O, {
                                breadcrumbs: breadCrumbs
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PbBuildPC, {
                            pbContent: pbContent,
                            pbSSRData: pbSSRData,
                            pbMetaData: pbMetaData,
                            page: "buildpc"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintBuildPc_es/* PrintBuildPc */.r, {
                total: estimatedAmount,
                buildpc: mappedPrintBuildPCData,
                logoProps: {
                    height: "60px"
                }
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPc/* BuildPc */.k, {});
};
const StyledContainer = (0,emotion_styled_browser_esm["default"])(Container_es/* Container */.W)(_templateObject());

// EXTERNAL MODULE: ./contexts/BuildPcContext.tsx
var BuildPcContext = __webpack_require__(677111);
;// CONCATENATED MODULE: ./tenants/phongvu/desktop/buildpc.tsx
function buildpc_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function buildpc_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            buildpc_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





const BuildPcPage = (props)=>{
    const { epicOmni1524  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const BuildPCProvider = !!epicOmni1524 ? BuildPCContextV2/* BuildPCV2Provider */.k : BuildPcContext/* BuildPcProvider */.sf;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPCProvider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPC, buildpc_objectSpread({}, props))
    });
};
const getServerSideProps = (/* unused pure expression or super */ null && (getServerSidePropsBuildPC));
/* harmony default export */ var buildpc = (BuildPcPage);

;// CONCATENATED MODULE: ./pages/phongvu/desktop/buildpc.tsx
// AUTO GENERATED FILE. DO NOT EDIT.

var __N_SSP = true;
/* harmony default export */ var desktop_buildpc = (buildpc);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [54615,42661,57616,8278,39486,35970,10398,93712,49774,92888,40179], function() { return __webpack_exec__(325523); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);